<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="当事人" min-width="120" >
            <template slot-scope="scope">
              {{ scope.row.party_name }}
            </template>
        </el-table-column>
        <el-table-column label="案号">
            <template slot-scope="scope">
              {{ scope.row.case_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="执行标的金额">
            <template slot-scope="scope">
              {{ scope.row.execution_target_amount || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="未偿还金额">
            <template slot-scope="scope">
              {{ scope.row.outstanding_amount || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="法院名称（执行者）">
            <template slot-scope="scope">
              {{ scope.row.court_name || '-' }}
            </template>
        </el-table-column>
        
        <el-table-column label="终本日期">
            <template slot-scope="scope">
              {{ scope.row.final_version_date || '-' }}
            </template>
        </el-table-column>
        
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'finalVersionCaseList',
    data() {
        return {
            title: '终本案件',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>